import React, {useEffect, useState} from "react";
import {changeTwoFactorMethod} from "../../../../components/requests";
import {toast} from "react-toastify";
import {useAuth} from "../../../contexts/AuthContext";
import {useNavigate} from "react-router-dom";
import {IconSpinner} from "../../../../components/icons";

const SwitchMethod = ({id, method}) => {
  const {setTwoFactorStep} = useAuth();
  const navigate = useNavigate();
  const [methodChanging, setMethodChanging] = useState<boolean>(false);
  const [twofactorMethod, setTwofactorMethod] = useState<string | null>(id ?? null);
  const [utilisateurId, setUtilisateurId] = useState<number | null>(method ?? null);

  // Enregistrement des données en props dans des states
  useEffect(() => {
    setUtilisateurId(id ?? null);
    setTwofactorMethod(method ?? null);
  }, [id, method]);

  // Méthode de modification du 2FA de l'utilisateur
  const handleChangeMethod = (method: string) => {
    setMethodChanging(true);
    setTwofactorMethod(method);
    changeTwoFactorMethod(utilisateurId, method)
      .then((response) => {
        if (response?.status === 200 && response?.data !== undefined) {
          localStorage.setItem('accessToken', response?.data?.token);
          setTwoFactorStep(method === "email" ? 'verify' : 'setup');
        }
      })
      .catch((error) => {
        console.error('error', error);
        toast.error(error?.response?.data?.detail ?? 'Une erreur est survenue');
      })
      .finally(() => {
        setMethodChanging(false);
        navigate(method === "email" ? '/auth/verify-2fa' : '/auth/setup-2fa', {
          state: {
            id: utilisateurId,
            twoFactorMethod: method
          }
        });
      });
  }

  // Tableau de méthode pour eviter les redondances de code
  const METHODS = [
    { value: "email", label: "Email" },
    { value: "totp", label: "Application (TOTP)" },
  ];

  return (
    <div className="mt-6 border-t border-gray-100 pt-4 text-center">
      <p className="mb-2 text-xs text-gray-500">Méthode de vérification</p>
      <div
        className={`inline-flex rounded-lg bg-gray-100 p-1 text-sm font-medium transition ${
          methodChanging ? "opacity-70" : ""
        }`}
        aria-busy={methodChanging}
      >
        {METHODS.map(({ value, label }) => {
          const isSelected = twofactorMethod === value;
          const isLoading = methodChanging && isSelected;

          return (
            <label key={value} className="cursor-pointer">
              <input
                type="radio"
                name="method"
                value={value}
                className="peer sr-only"
                checked={isSelected}
                onChange={(e) => handleChangeMethod(e.target.value)}
                disabled={methodChanging}
              />
              <span
                className={`inline-flex items-center gap-1 rounded-md px-4 py-1.5 text-gray-500 transition
                peer-checked:bg-white peer-checked:text-emerald-600 peer-checked:shadow-sm
                ${isLoading ? "animate-pulse" : ""}`}
              >
                {isLoading && (
                  <IconSpinner
                    className="h-4 w-4 shrink-0 animate-spin text-emerald-600"
                    aria-hidden="true"
                  />
                )}
                {label}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}

export default SwitchMethod;